// components/FiltrarMedios/FiltrarMediosService.js
import axios from 'axios';
import { UrlApi } from "../../../services/apirest";

export const filtrarMediosService = {
  // Obtener todos los filtros
  getAll: async () => {
    const response = await axios.get(UrlApi+"/envasado_filtro_medios");
    return response.data;
  },

  // Crear filtro
  create: async (data) => {
    const response = await axios.post(UrlApi+"/envasado_filtro_medios", data);
    return response.data;
  },

  // Actualizar filtro
  update: async (id, data) => {
    const response = await axios.put(`${UrlApi}/envasado_filtro_medios/${id}`, data);
    return response.data;
  },

  // Eliminar filtro
  delete: async (id) => {
    const response = await axios.delete(`${UrlApi}/envasado_filtro_medios/${id}`);
    return response.data;
  },

  // Obtener choferes
  getChoferes: async () => {
    const response = await axios.get(`${UrlApi}/choferes/`);
    return response.data;
  },

  // Obtener medios disponibles
  getMediosDisponibles: async () => {
    const response = await axios.get(
      `${UrlApi}/envasado_medios_pago/xnegocio/envasado`
    );
    return response.data;
  },

verificarFiltro: async (id_chofer) => {
    const response = await axios.get(`${UrlApi}/envasado_filtro_medios/verificar/${id_chofer}`);
    return response.data;
  },
};